import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {LeadButtonTerms} from "../../../lead/components/LeadButtonTerms";
import {LeadRodoTerms} from "../../../lead/components/LeadRodoTerms";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../../types/AuthActionType";
import {ExtendedRegisterForm} from "./ExtendedRegisterForm";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToLogin: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    title: ReactNode | string;
    description?: ReactNode | string;
    gtmEventData?: () => void;
    wrapperClassName?: string;
}

const registerButtonText = "ZAŁÓŻ KONTO";

export const ExtendedRegisterCard = (props: IProps) => {
    return (
        <div className={cx(wrapperStyle, props.wrapperClassName)}>
            {props.title}

            <ExtendedRegisterForm
                registerButtonText={registerButtonText}
                onAuthSuccess={props.onAuthSuccess}
                gtmEventData={props.gtmEventData}
                userSource={props.userSource}
                gtmSourceSection={props.gtmSourceSection}
            />

            <div className={loginSectionStyle}>
                <Text variant="info_txt_1" align="center">
                    Masz już konto?
                </Text>

                <Button onClick={props.onSwitchToLogin} variant="highlight_primary">
                    ZALOGUJ SIĘ
                </Button>
            </div>

            <div className={leadTermsStyle}>
                <LeadRodoTerms align="center" />
                <LeadButtonTerms align="center" buttonText={registerButtonText} />
            </div>
        </div>
    );
};

const wrapperStyle = css({
    width: "100%",
    backgroundColor: "#fff",
    padding: 1.5,
    md: {
        padding: 3
    }
});

const loginSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    position: "relative",
    paddingTop: 3,
    paddingBottom: 1.5
});

const leadTermsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    textAlign: "center"
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

import {LeadButtonTerms} from "../../../lead/components/LeadButtonTerms";
import {LeadRodoTerms} from "../../../lead/components/LeadRodoTerms";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../../types/AuthActionType";
import {ExtendedRegisterForm} from "./ExtendedRegisterForm";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToLogin: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    title: ReactNode | string;
    description?: ReactNode | string;
    gtmEventData?: () => void;
    wrapperClassName?: string;
}

const registerButtonText = "ZAŁÓŻ KONTO";

export const ExtendedRegisterCard = (props: IProps) => {
    return (
        <div className={cx(wrapperStyle, props.wrapperClassName)}>
            {props.title}

            <ExtendedRegisterForm
                registerButtonText={registerButtonText}
                onAuthSuccess={props.onAuthSuccess}
                gtmEventData={props.gtmEventData}
                userSource={props.userSource}
                gtmSourceSection={props.gtmSourceSection}
            />

            <div className={loginSectionStyle}>
                <Text variant="info_txt_1" align="center">
                    Masz już konto?
                </Text>

                <Button onClick={props.onSwitchToLogin} variant="highlight_primary">
                    ZALOGUJ SIĘ
                </Button>
            </div>

            <div className={leadTermsStyle}>
                <LeadRodoTerms align="center" />
                <LeadButtonTerms align="center" buttonText={registerButtonText} />
            </div>
        </div>
    );
};

const wrapperStyle = css({
    width: "100%",
    backgroundColor: "#fff",
    padding: 1.5,
    md: {
        padding: 3
    }
});

const loginSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    position: "relative",
    paddingTop: 3,
    paddingBottom: 1.5
});

const leadTermsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    textAlign: "center"
});
